import React from 'react';
import c from '../w.js';

const IconArrowDownRight = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00001 19H19V8H17V15.5858L6.70712 5.29289L5.29291 6.70711L15.5858 17H8.00001V19Z"
      }
    )
  )
);

export { IconArrowDownRight };
